import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

function OrderSuccessPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    const orderId = searchParams.get('orderId');
    const paymentId = searchParams.get('paymentId');

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
                <div className="flex justify-center mb-6">
                    <CheckCircle className="w-20 h-20 text-green-500" />
                </div>
                
                <h1 className="text-3xl font-bold text-gray-800 mb-4">
                    Ödeme Başarılı!
                </h1>
                
                <p className="text-gray-600 mb-6">
                    Siparişiniz başarıyla oluşturuldu. Teşekkür ederiz!
                </p>
                
                {orderId && (
                    <div className="bg-gray-50 rounded-lg p-4 mb-6">
                        <p className="text-sm text-gray-500 mb-1">Sipariş Numarası</p>
                        <p className="text-lg font-mono font-semibold text-gray-800">
                            {orderId}
                        </p>
                    </div>
                )}
                
                <div className="space-y-3">
                    <button
                        onClick={() => navigate('/my-orders')}
                        className="w-full bg-brand-primary hover:bg-brand-secondary text-white font-semibold py-3 rounded-lg transition-colors"
                    >
                        Siparişlerimi Görüntüle
                    </button>
                    
                    <button
                        onClick={() => navigate('/')}
                        className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 rounded-lg transition-colors"
                    >
                        Alışverişe Devam Et
                    </button>
                </div>
                
                <div className="mt-6 pt-6 border-t border-gray-200">
                    <p className="text-xs text-gray-500">
                        Sipariş detayları e-posta adresinize gönderilecektir.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default OrderSuccessPage;
